import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { DefaultHttpError } from 'app/core/constants/error-codes';
import { TranslationService } from 'app/core/services/translation.service';
import { ToastKeys } from 'app/core/constants';
import { getBadRequestDetail } from 'app/core/utils';

const defaultToastOptions: ToastMessageOptions = {
  severity: 'warn',
  closable: true,
  life: 36000,
  key: ToastKeys.httpError,
};

export const SUPPRESS_HTTP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export const errorInterceptorFn: HttpInterceptorFn = (req, next) => {
  const toastService = inject(MessageService);
  const translationService = req.url.match(/\/api\//)
    ? inject(TranslationService, {
        optional: true,
      })
    : null;
  const displayError = !/\/profile-picture/.test(req.url) && !req.context.get(SUPPRESS_HTTP_ERROR_TOAST);

  return next(req).pipe(
    catchError(err => {
      if (displayError && err instanceof HttpErrorResponse && translationService) {
        const errorCode = ` : ${err.error.code ?? DefaultHttpError}`;
        const errorDetail = getBadRequestDetail(err.error);

        if (err.status === 400) {
          if (errorDetail?.toString()?.toLowerCase().includes('unrecognized request url')) {
            // console.error(messages);
            // Suppress the error for this specific case
          } else {
            toastService.add({
              ...defaultToastOptions,
              detail: errorDetail ?? undefined,
              summary: translationService.translateMsg('messages.errorOccurredTitle') + errorCode,
            });
          }
        } else if ([401, 403].includes(err.status)) {
          toastService.add({
            ...defaultToastOptions,
            detail: translationService.translateMsg('messages.unauthorizedError'),
            summary: translationService.translateMsg('messages.unauthorizedErrorTitle') + errorCode,
          });
        } else if (err.status === 404) {
          if (!/\/shipment-status\//.test(req.url)) {
            toastService.add({
              ...defaultToastOptions,
              detail: translationService.translateMsg('messages.notFoundError'),
              summary: translationService.translateMsg('messages.notFoundErrorTitle') + errorCode,
            });
          }
        } else if (err.status === 500) {
          toastService.add({
            ...defaultToastOptions,
            detail: errorDetail ?? undefined,
            summary: err.error.code,
          });
        } else if (err.status === 0) {
          toastService.add({
            ...defaultToastOptions,
            detail: translationService.translateMsg('messages.networkErrorContent'),
            summary: translationService.translateMsg('messages.networkErrorTitle'),
          });
        }
      }

      return throwError(() => err);
    })
  );
};
